
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";

import { UserPermissions, FeaturesList } from "@/store/types";

import { get } from "lodash";

const Areas = namespace("areas");
const Regions = namespace("regions");

@Component({})
export default class AreaSchedule extends Vue {
	@Prop({ required: true, type: Number, default: 0 }) areaId: number;
	@Prop({ type: Number, default: 0 }) regionId: number;

	@Getter getPermissions: UserPermissions;

	@Areas.Action private getWeeklyDisarmSchedule: ({areaId: number, regionUrl: string}) => Promise<any>;
	@Regions.Getter private getRegionUrl: (regionId: number) => string;

	public schedule = null;

	@Watch("areaId")
	private async areaChagned(): Promise<void>{
		await this.runSchedule();
	}
	
	@Watch("regionId")
	private async regionChagned(): Promise<void>{
		await  this.runSchedule();
	}

	async mounted() {
		this.runSchedule();
	}

	private async runSchedule(): Promise<void>{
		if (this.areaId > 0) {
			let regionUrl = this.getRegionUrl(this.regionId);

			this.schedule = await this.getWeeklyDisarmSchedule({areaId: this.areaId, regionUrl: regionUrl});
		}
	}

	private userHasPermission() {
		return this.getPermissions.canViewSiteSetup || this.getPermissions.canHandleAlarms;
	}

	private getDisarmPeriodStyling(period) {
		return {
			left: period.startPoint + "%",
			width: period.endPoint - period.startPoint + "%"
		};
	}
}
